import { createContext, useContext, useState } from "react";

let initialState = {
    open : false,
    documentTitle:  "",
    documentDownloadUrl : "",
    documentViewUrl : "",
    onSubmit:undefined,
    fileStatus:undefined,
    isApproval:false,
    download:false
} 

const DocumentViewerContext = createContext(null);

export const useDocumentViewer = ()=> useContext(DocumentViewerContext);

export function DocumentViewerProvider({children}){
    const [documentState,setDocumentState] = useState({...initialState})
    return <DocumentViewerContext.Provider value={{documentState,setDocumentState}}>
        {children}
    </DocumentViewerContext.Provider>
}